import {AbstractControl, ValidationErrors} from '@angular/forms';
import {Injectable} from "@angular/core";
import {TicketChangePolicyService} from '../../api';

@Injectable()
export class TicketChangePolicyValidator {
  constructor(private ticketChangePolicyService: TicketChangePolicyService) {
  }

  static readonly codePattern = /^[a-zA-Z0-9-]+$/;

  public editingObject: any;

  ticketChangePolicyCodeTaken = (control: AbstractControl) => {
    return new Promise<ValidationErrors | null>((resolve) => {
      const v = control.value;
      setTimeout(() => {
        if (v === '') {
          resolve(null);
          return;
        }

        this.ticketChangePolicyService.getTicketChangePolicyByCode(v).subscribe({
          next: (data) => {
            if (data !== null && data !== void 0) {
              if (data.Id != this.editingObject.Id) {
                resolve({"codetaken": data});
              }
            }
            resolve(null);
          },
          error: () => {
            resolve(null);
          }
        });
      }, 200);
    });
  }
}
